<template>
  <v-dialog v-model="dialog" persistent max-width="800px" content-class="view-service-dialog" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on }">
      <SecondaryBtn icon="description" small v-on="on">
        {{$t('Button.ServiceCapabilities')}}
      </SecondaryBtn>
    </template>
    <template v-if="dialog">
      <v-flex>
        <v-card flat dark>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Service Capabilities</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()" dark>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
      </v-flex>
      <v-flex style="overflow: auto;">
        <v-card flat>
          <v-card-text>
            Capabilities are details about what this service can do. Details may include which tenants are using
            the service, and whether there were errors reaching the service.
          </v-card-text>
          <v-divider />
          <v-card-text class="word-break pa-0 ma-0">
            <TreeViewComponent :data="{ value: service }" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card style="border-top: 1px solid #dddddd;">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" outline @click="close()">{{$t('Button.Close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </template>
  </v-dialog>
</template>

<script>
  import {
    fileExportNamesMixin,
  } from '@/components/mixins/uiConfigUtil'

  export default {
    mixins: [fileExportNamesMixin],
    props: {
      service: Object,
    },
    data: () => ({
      dialog: false,
      debugKeys: ['StatusCode', 'DisplayMessage', 'IsError', 'ReasonPhrase'],
    }),
    computed: {
      capabilities() {
        return this.removeDebugKeys(this.service.Capabilities)
      },
      tenants() {
        return this.$store.getters['admin/roleList']
      },
      fileExportNames() {
        return this.$store.getters['uiconfig/fileExportNames']
      },
    },
    methods: {
      close() {
        this.dialog = false
      },
      removeDebugKeys(capabilities) {
        if (capabilities == null) {
          return capabilities
        }

        let output = JSON.parse(JSON.stringify(capabilities))
        this.debugKeys.forEach(key => delete output[key])

        if (!this.hasKeys(output)) {
          return null
        }

        return output
      },
      hasKeys(val) {
        return Object.keys(val).length > 0
      },
    },
  }
</script>

<style scoped>
  .word-break {
    word-break: break-all;
  }

  .v-dialog--fullscreen>.v-card {
    min-height: 85px !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card {
    min-height: Calc(100% - 85px) !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card .v-card__text {
    padding: 0px !important;
  }
</style>
<style>
  .view-service-dialog {
    display: flex;
    flex-direction: column;
  }
</style>